module.exports = __webpack_public_path__ + "img/move.204d1c80.svg";